"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const malty_atoms_icon_wrapper_1 = require("@carlsberggroup/malty.atoms.icon-wrapper");
const react_1 = __importDefault(require("react"));
const Compass = (props) => (0, malty_atoms_icon_wrapper_1.IconWrapper)(props, react_1.default.createElement("g", { fillRule: "evenodd" },
    react_1.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }),
    react_1.default.createElement("path", { d: "M6.625 21.982c-.77.616-1.874-.137-1.58-1.08l6.002-19.2c.292-.936 1.616-.936 1.908 0l6.001 19.2c.295.943-.808 1.696-1.579 1.08l-5.376-4.301zm9.446-3.606l-4.07-13.024-4.07 13.024 3.445-2.757a1 1 0 011.25 0z" })));
exports.default = Compass;
//# sourceMappingURL=index.js.map